import { Sort } from './sort';

interface PageRequestModel<T> {
  size?: number;
  page?: number;
  sort?: Sort[];
  query?: T;
  sortOrder?: string;
  surveyStatus?: string;
  sortField?: string;
}

export class PageRequest<T> {
  size: number;
  page: number;
  sort: Sort[];
  query: T;
  sortOrder: string;
  surveyStatus: string;
  sortField: string;

  constructor({
    size,
    page,
    sort,
    query,
    sortOrder,
    surveyStatus,
    sortField
  }: PageRequestModel<T> = {}) {
    this.surveyStatus = surveyStatus;
    this.sortField = sortField;
    this.sortOrder = sortOrder;
    this.query = query;
    this.size = size;
    this.page = page;
    this.sort = sort;
  }
}
